export default __webpack_public_path__ + "static/banner-two-shape8-82e705444e8dc82023ac2e43e4fd1e75.png";